<template>

  <b-card
    class="mb-1"
    style="margin:0;border:1px solid #c9c9c9;"
    
  >
    <b-card-header
      header-tag="header" 
      role="tab"
      block 
      @click="visibleBody = !visibleBody"
      style="padding:0; cursor: pointer;"
    >
      <span class="mr-5">PRENATALES</span>
      <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
    </b-card-header>
    <b-collapse 
      v-model="visibleBody" 
      id="collapse-4"
    >
      <b-card-body >
        
        <b-row class="my-2">

          <b-col class="col-4">
            <label> Edad de la madre:</label>
            <b-form-input 
              type="number" 
              v-model="prenatal.edadMadre"
              class="col-6"
              min="0"
              max="99"
              :disabled="onlyView"
            />
          </b-col>

          <b-col class="col-6"> 
            <label> Educación de la madre:</label>
            <v-select
              placeholder="Seleccione una o mas opciones"
              :options="educacionOpts"
              :reduce="option => option"
              label="text"
              v-model="prenatal.educacionMadre"
              :disabled="onlyView"
            />
          </b-col>
          
        </b-row>

        <hr>

        <b-row>
          <b-col class="col-5">

            <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
              <label class="col-7"> Gestas:</label>
              <b-form-input 
                type="number" 
                v-model="nGestas"
                class="col-3"
                min="0"
                max="99"
                disabled
              />
            </b-row>

            <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
              <label class="col-7"> Partos Naturales:</label>
              <b-form-input 
                type="number" 
                v-model="prenatal.partosNaturales"
                class="col-3"
                min="0"
                max="99"
                :disabled="onlyView"
              />
            </b-row>

            <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
              <label class="col-7"> Cesareas:</label>
              <b-form-input 
                type="number" 
                v-model="prenatal.cesareas"
                class="col-3"
                min="0"
                max="99"
                :disabled="onlyView"
              />
            </b-row>

            <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
              <label class="col-7"> Abortos:</label>
              <b-form-input 
                type="number" 
                v-model="prenatal.abortos"
                class="col-3"
                min="0"
                max="99"
                :disabled="onlyView"
              />
            </b-row>

            <b-row class="d-flex align-items-center" style="margin-bottom: 5px;">
              <label class="col-7"> Control prenatal:</label>
              <b-form-input 
                type="number" 
                v-model="prenatal.nControles"
                class="col-3"
                min="0"
                max="99"
                :disabled="onlyView"
              />
            </b-row>
            
          </b-col>

          <b-col class="col-7">

            <b-row class="mt-1">
              <label class="col-12"> Alimentación:</label>
              <v-select
                v-model="prenatal.alimentacion"
                class="col-12"
                placeholder="Seleccione una o mas opciones"
                :options="alimentacionOpts"
                :reduce="option => option"
                label="text"
                :multiple="true"
                taggable
                :disabled="onlyView"
              />
            </b-row>

            <b-row class="mt-1">
              <label class="col-12"> Enfermedades en embarazo:</label>
              <v-select
                class="col-12"
                placeholder="Seleccione una o mas opciones"
                :options="enfEmbarazoOpts"
                label="text"
                v-model="prenatal.enfermedadesEmbarazo"
                :disabled="onlyView"
              />
              <b-form-input 
                v-if="prenatal.enfermedadesEmbarazo && prenatal.enfermedadesEmbarazo.value === 'otras'" 
                v-model="prenatal.otraEnfermedad"
                placeholder="Describa la otra enfermedad.." 
                class="mt-1 mx-1"
                :disabled="onlyView"
              />
            </b-row>


            <b-row class="mt-1">
              <label class="col-12">Medicacion durante embarazo:</label>
              
              <b-form-input 
                v-model="prenatal.medicacionEmbarazo"
                placeholder="Describa la medicacion.." 
                class="mx-1"
                :disabled="onlyView"
              />
            </b-row>

            <b-row class="mt-1">
              <label class="col-12">Grupo sanguíneo y factor RH::</label>
              <v-select
                class="col-12"
                placeholder="Seleccione una o mas opciones"
                :options="tipoSangreOpts"
                :reduce="option => option"
                label="text"
                v-model="prenatal.tipoSangre"
                :disabled="onlyView"
              />
            </b-row>
            
          </b-col>

        </b-row>
        
      </b-card-body>
    </b-collapse>

  </b-card>

      
</template>

<script>
import { mapState } from 'vuex';
import vSelect from 'vue-select';
import { addNewOpt } from '@/shared/helpers';

export default {
  name: "Prenatales",


  props: {
    onlyView: {
      type: Boolean,
      default: false
    }
  },

  components: {
    vSelect
  },


  data() {
    return {
      visibleBody: false,

      prenatal: {
        edadMadre: 0,
        educacionMadre: false,

        gestas: 0,
        partosNaturales: 0,
        cesareas: 0,
        abortos: 0,
        nControles: 0,

        alimentacion: '',
        enfermedadesEmbarazo: '',
        medicacionEmbarazo: '',
        otraEnfermedad:null,
        
        tipoSangre: ''
      },

      educacionOpts:[
        { value:'no_refiere',               text: 'No refiere' },
        { value:'sin educacion',            text: 'Sin educación' },
        { value:'primaria',                 text: 'Primaria' },
        { value:'basica',                   text: 'Básica' },
        { value:'secundaria',               text: 'Secundaria' },
        { value:'universitaria',            text: 'Universitaria' },
        { value:'universitaria_cursando',   text: 'Universitaria cursando' },
        { value:'universitaria_incompleta', text: 'Universitaria incompleta' },
        { value:'universitaria_completa',   text: 'Universitaria completa' }
      ],


      alimentacionOpts: [
        "Hipercalórica", 
        "Hipoprotéica", 
        "Hipocalórica", 
        "Normocalórica"
      ],

      enfEmbarazoOpts: [
        { value: "placenta_previa",          text: "Placenta previa" },
        { value: "preeclampsia",             text: "Preeclampsia" },
        { value: "diabetes_gestacional",     text: "Diabetes gestacional" },
        { value: "rubiola",                  text: "Rubiola" },
        { value: "toxoplasmosis",            text: "Toxoplasmosis" },
        { value: "infección_vías_urinarias", text: "Infección vías urinarias" },
        { value: "ninguna",                  text: "Ninguna" },
        { value: "otras",                    text: "Otras" },
      ],

      tipoSangreOpts:[
        { value: "A+",  text: "A+" },
        { value: "A-",  text: "A-" },
        { value: "B+",  text: "B+" },
        { value: "B-",  text: "B-" },
        { value: "AB+", text: "AB+" }, 
        { value: "AB-", text: "AB-" },
        { value: "O+",  text: "O+" },
        { value: "O-",  text: "O-" }
      ]
        
    }
  },

  methods: {
    
    onAddNewOpt(newArray) {
      return addNewOpt(newArray);
    },

    resetPrenatal(){
      this.prenatal = {
        edadMadre: 0,
        educacionMadre: false,
        enfermedadesEmbarazo:null,
        otraEnfermedad:null,
        medicacionEmbarazo: '',
        gestas: 0,
        partosNaturales: 0,
        cesareas: 0,
        abortos: 0,
        nControles: 0,
        
        alimentacion: '',
        enfermedades: '',
        tipoSangre: ''
      }
    },

  },


  computed: {
    ...mapState({
      stSemPediatrica: state => state.atencionCita.semiologias?.semPediatrica,
      stSemiologiaView: state => state.atencionMedica.dataAtencion.semiologiaView
    }),


    nGestas(){
      const n1 = parseInt(this.prenatal.partosNaturales);
      const n2 = parseInt(this.prenatal.cesareas);
      const n3 = parseInt(this.prenatal.abortos);
      return n1 + n2 + n3;
    }

  },

  watch: {

    stSemPediatrica: {
      immediate: true,
      deep: true,

      handler(newVal) {
        if(this.onlyView) return;

        // const tokenAtencion = this.$route.params.token;
        // if(!tokenAtencion) return;

        if (newVal.prenatal) this.prenatal = newVal.prenatal;
      }
    },


    stSemiologiaView:{
      immediate: true,
      handler(newValue){

        if(!this.onlyView) return;

        this.resetPrenatal();

        if(newValue?.prenatal) this.prenatal = newValue?.prenatal;
        
      }
    },

    
    prenatal: {
      deep:true,
      immediate:true,
      handler(newValue){

        if(this.onlyView) return;
        this.$store.commit("setPreNatales", newValue);
      }
    },

  }
}
</script>